<template>
  <div class="row mx-0">
    <commonQueryInput
      :inputItems="multiInputItems"
      v-model:getValue="multiInputVal"
    ></commonQueryInput>
    <div class="d-flex justify-content-end text-end">
      <div
        class="py-1 px-2"
        style="background: #c8c9ca; min-width: max-content"
      >
        <span>異動人員：{{ username }}</span>
      </div>
    </div>
    <div class="col-12">
      <div
        class="table-responsive my-2"
        style="max-height: 500px"
        ref="roleTable"
      >
        <table class="table table-style" :class="{ mod: mod }">
          <thead>
            <tr>
              <th v-if="mod"></th>
              <th colspan="2">基本資料</th>
              <th :colspan="countRightInWebPage(webPage)">對應權限</th>
            </tr>
            <tr>
              <th v-if="mod" :rowspan="rowspan + 1">刪除</th>
              <th :rowspan="rowspan + 1">編號</th>
              <th :rowspan="rowspan + 1">名稱</th>
              <template v-if="webPage.length == 0">
                <th :colspan="countRightInWebPage(webPage)"></th>
              </template>
              <template v-for="(firstItem, firstIndex) in webPage">
                <th
                  class=""
                  :colspan="countRightRecursive(firstItem)"
                  :rowspan="rowspan - countLevelsRecursive(firstItem) + 1"
                >
                  {{ firstItem.name }}
                </th>
              </template>
            </tr>
            <!-- 
┌──────────────────┬────────────────────────────────────────────────────────────┬───────────────────────────────────────────────┐
│                  │                          elecboard                         │                                               │
│       home       ├────────────────────────────────────────────────────────────┤                                               │
│                  │                      elecboardforging3                     │               permissionsetting               │
├──────────────────┼───────────────┬─────────────┬─────────────┬────────────────┤                                               │
│   homeforging3   │   annealing   │   forging   │   heating   │   preheating   │                                               │
├──────────────────┼───────────────┼─────────────┼─────────────┼────────────────┼───────────┬───────────┬───────────┬───────────┤
│         R        │        R      │      R      │      R      │        R       │     C     │     R     │     U     │     D     │
└──────────────────┴───────────────┴─────────────┴─────────────┴────────────────┴───────────┴───────────┴───────────┴───────────┘
             -->
            <tr>
              <template v-for="firstItem in webPage">
                <template v-if="firstItem.children.length != 0">
                  <template v-for="secondItem in firstItem.children">
                    <template v-if="secondItem.children.length != 0">
                      <th
                        class=""
                        style="border-left: 0px"
                        :colspan="countRightRecursive(secondItem)"
                      >
                        {{ secondItem.name }}
                      </th>
                    </template>
                    <template v-else-if="countLevelsRecursive(firstItem) == 3">
                      <th
                        class=""
                        style="border-left: 0px"
                        :rowspan="rowspan - countLevelsRecursive(secondItem)"
                        :colspan="countRightRecursive(secondItem)"
                      >
                        {{ secondItem.name }}
                      </th>
                    </template>
                  </template>
                </template>
              </template>
            </tr>
            <tr>
              <template v-for="firstItem in webPage">
                <template v-if="firstItem.children.length != 0">
                  <template v-for="secondItem in firstItem.children">
                    <template v-if="secondItem.children.length != 0">
                      <template v-for="thirdItem in secondItem.children">
                        <th
                          class=""
                          style="border-left: 0px"
                          :colspan="thirdItem.right.length"
                        >
                          {{ thirdItem.name }}
                        </th>
                      </template>
                    </template>
                    <template v-else-if="countLevelsRecursive(firstItem) == 2">
                      <th :colspan="secondItem.right.length">
                        {{ secondItem.name }}
                      </th>
                    </template>
                  </template>
                </template>
              </template>
            </tr>
            <tr>
              <template v-for="firstItem in webPage">
                <template v-if="firstItem.children.length == 0">
                  <template v-for="accessType in firstItem.right">
                    <template v-if="accessType == 'C'">
                      <th style="border-left: 0px">新增</th>
                    </template>
                    <template v-else-if="accessType == 'R'">
                      <th style="border-left: 0px">查詢</th>
                    </template>
                    <template v-else-if="accessType == 'U'">
                      <th style="border-left: 0px">修改</th>
                    </template>
                    <template v-else-if="accessType == 'D'">
                      <th style="border-left: 0px">刪除</th>
                    </template>
                    <template v-else></template>
                  </template>
                </template>
                <template v-else>
                  <template v-for="secondItem in firstItem.children">
                    <template v-if="secondItem.children.length == 0">
                      <template v-for="accessType in secondItem.right">
                        <template v-if="accessType == 'C'">
                          <th style="border-left: 0px">新增</th>
                        </template>
                        <template v-else-if="accessType == 'R'">
                          <th style="border-left: 0px">查詢</th>
                        </template>
                        <template v-else-if="accessType == 'U'">
                          <th style="border-left: 0px">修改</th>
                        </template>
                        <template v-else-if="accessType == 'D'">
                          <th style="border-left: 0px">刪除</th>
                        </template>
                        <template v-else></template>
                      </template>
                    </template>
                    <template v-else>
                      <template v-for="thirdItem in secondItem.children">
                        <template v-for="accessType in thirdItem.right">
                          <template v-if="accessType == 'C'">
                            <th style="border-left: 0px">新增</th>
                          </template>
                          <template v-else-if="accessType == 'R'">
                            <th style="border-left: 0px">查詢</th>
                          </template>
                          <template v-else-if="accessType == 'U'">
                            <th style="border-left: 0px">修改</th>
                          </template>
                          <template v-else-if="accessType == 'D'">
                            <th style="border-left: 0px">刪除</th>
                          </template>
                          <template v-else></template>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-if="add">
              <tr>
                <td>
                  <input
                    type="text"
                    name="roleId"
                    v-model="addRole_webPage_right.role_id"
                    class="w-100"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="roleName"
                    v-model="addRole_webPage_right.name"
                    class="w-100"
                    autocomplete="off"
                  />
                </td>

                <template v-for="firstItem in webPage">
                  <template v-if="firstItem.children.length == 0">
                    <template v-for="accessType in firstItem.right">
                      <td
                        style="border-left: 0px"
                        class="changeAccessStyle"
                        @click="
                          changeAccess(
                            'add',
                            index,
                            firstItem.webPage_id,
                            accessType
                          )
                        "
                      >
                        <template
                          v-if="
                            checkAccess(
                              addRole_webPage_right,
                              firstItem,
                              accessType
                            )
                          "
                        >
                          V
                        </template>
                      </td>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="secondItem in firstItem.children">
                      <template v-if="secondItem.children.length == 0">
                        <template v-for="accessType in secondItem.right">
                          <td
                            style="border-left: 0px"
                            class="changeAccessStyle"
                            @click="
                              changeAccess(
                                'add',
                                index,
                                secondItem.webPage_id,
                                accessType
                              )
                            "
                          >
                            <template
                              v-if="
                                checkAccess(
                                  addRole_webPage_right,
                                  secondItem,
                                  accessType
                                )
                              "
                            >
                              V
                            </template>
                          </td>
                        </template>
                      </template>
                      <template v-else>
                        <template v-for="thirdItem in secondItem.children">
                          <template v-for="accessType in thirdItem.right">
                            <td
                              style="border-left: 0px"
                              class="changeAccessStyle"
                              @click="
                                changeAccess(
                                  'add',
                                  index,
                                  thirdItem.webPage_id,
                                  accessType
                                )
                              "
                            >
                              <template
                                v-if="
                                  checkAccess(
                                    addRole_webPage_right,
                                    thirdItem,
                                    accessType
                                  )
                                "
                              >
                                V
                              </template>
                            </td>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </tr>
            </template>
            <template v-for="(item, index) in role_webPage_right">
              <tr>
                <td v-if="mod">
                  <input
                    type="checkbox"
                    name="delCheckbox"
                    :value="item.role_id"
                    v-model="delCheckbox"
                  />
                </td>
                <td>{{ item.role_id }}</td>
                <td>
                  <template v-if="mod">
                    <input
                      type="text"
                      name="roleName"
                      v-model="role_webPage_right[index].name"
                      class="w-100"
                      autocomplete="off"
                    />
                  </template>
                  <template v-else>
                    {{ item.name }}
                  </template>
                </td>

                <template v-for="firstItem in webPage">
                  <template v-if="firstItem.children.length == 0">
                    <template v-for="accessType in firstItem.right">
                      <td
                        style="border-left: 0px"
                        :class="{ changeAccessStyle: mod }"
                        @click="
                          mod
                            ? changeAccess(
                                'mod',
                                index,
                                firstItem.webPage_id,
                                accessType
                              )
                            : ''
                        "
                      >
                        <template
                          v-if="checkAccess(item, firstItem, accessType)"
                        >
                          V
                        </template>
                      </td>
                    </template>
                  </template>
                  <template v-else>
                    <template v-for="secondItem in firstItem.children">
                      <template v-if="secondItem.children.length == 0">
                        <template v-for="accessType in secondItem.right">
                          <td
                            style="border-left: 0px"
                            :class="{ changeAccessStyle: mod }"
                            @click="
                              mod
                                ? changeAccess(
                                    'mod',
                                    index,
                                    secondItem.webPage_id,
                                    accessType
                                  )
                                : ''
                            "
                          >
                            <template
                              v-if="checkAccess(item, secondItem, accessType)"
                            >
                              V
                            </template>
                          </td>
                        </template>
                      </template>
                      <template v-else>
                        <template v-for="thirdItem in secondItem.children">
                          <template v-for="accessType in thirdItem.right">
                            <td
                              style="border-left: 0px"
                              :class="{ changeAccessStyle: mod }"
                              @click="
                                mod
                                  ? changeAccess(
                                      'mod',
                                      index,
                                      thirdItem.webPage_id,
                                      accessType
                                    )
                                  : ''
                              "
                            >
                              <template
                                v-if="checkAccess(item, thirdItem, accessType)"
                              >
                                V
                              </template>
                            </td>
                          </template>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="gap-2 d-md-flex justify-content-md-end">
      <template v-if="add == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addRoleCheck"
        >
          確認新增
        </button>
      </template>
      <template v-else-if="mod == true">
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="back"
        >
          取消修改
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modRoleCheck"
        >
          確定修改
        </button>
      </template>
      <template v-else>
        <button
          type="button"
          class="btn p-0 me-2"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="addRole"
        >
          新增
        </button>
        <button
          type="button"
          class="btn p-0"
          style="
            color: #fff;
            background-color: #4b8c80;
            width: 6rem;
            height: 2rem;
            font-size: 1.125rem;
          "
          @click="modRole"
        >
          進行修改
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, inject, ref, watch } from "vue";
import commonQueryInput from "@/components/commonQueryInput.vue";
import store from "@/store";
import isEqual from "lodash/isEqual";
import exportCsv from "@/components/exportCsv.vue";
export default {
  components: {
    commonQueryInput,
    exportCsv,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const account = ref(loginData.value.account);
    const username = ref(loginData.value.username);

    const path = inject("path");
    const roleOption = ref([]);
    const webPageOption = ref([]);
    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "category",
        label: "類別",
        type: "select",
        checkEmpty: true,
        disableText: "-- 選擇類別 --",
        options: [
          { text: "角色", value: "role" },
          { text: "頁面", value: "webPage" },
        ],
      },
      {
        key: "itemValue",
        label: "項目編號/名稱",
        type: "selectInputList",
        bindKey: "category",
        disableText: "-- 選擇項目編號/名稱 --",
        bindOptions: {
          role: computed(() => roleOption.value),
          webPage: computed(() => webPageOption.value),
        },
      },
    ]);

    const roleTable = ref(null);
    const rowspan = ref(1);
    const add = ref(false);
    const mod = ref(false);
    const addRole_webPage_right = ref({});
    const orgRole_webPage_right = ref({});

    const addRole = () => {
      addRole_webPage_right.value = {
        role_id: "",
        name: "",
        webPage_data: [],
      };
      add.value = true;
      mod.value = false;
      roleTable.value.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    const modRole = () => {
      orgRole_webPage_right.value = JSON.parse(
        JSON.stringify(role_webPage_right.value)
      );
      add.value = false;
      mod.value = true;
    };
    const back = () => {
      addRole_webPage_right.value = {};
      if (!isEmptyObject(orgRole_webPage_right.value)) {
        role_webPage_right.value = JSON.parse(
          JSON.stringify(orgRole_webPage_right.value)
        );
      }
      add.value = false;
      mod.value = false;
      delCheckbox.value = [];
    };
    const addRoleCheck = () => {
      console.log(addRole_webPage_right.value);
      if (addRole_webPage_right.value.role_id == "") {
        methods.setTimeoutAlert("編號不可為空");
        return;
      } else if (addRole_webPage_right.value.name == "") {
        methods.setTimeoutAlert("名稱不可為空");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "AddRoleWebPageRight";
      params["addRole_webPage_right"] = addRole_webPage_right.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("新增完成");
          queryRoleWebPageRight("role", addRole_webPage_right.value.role_id);
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };
    const modRoleCheck = () => {
      const updateData = {
        nameUpdate: [],
        webPageDataUpdate: [],
        deletedRoles: [],
      };

      // 檢查被刪除的角色
      delCheckbox.value.forEach((id) => {
        const roleIndex = role_webPage_right.value.findIndex(
          (role) => role.role_id === id
        );
        if (roleIndex !== -1) {
          const orgRole = orgRole_webPage_right.value[roleIndex]; // 從 orgRole_webPage_right 中獲取原始數據
          updateData.deletedRoles.push({
            role_id: id,
            webPage_data: orgRole.webPage_data,
          });
          // 移除被刪除的角色
          role_webPage_right.value.splice(roleIndex, 1);
          orgRole_webPage_right.value.splice(roleIndex, 1); // 同時也從 orgRole_webPage_right 中移除相應的元素
        }
      });

      role_webPage_right.value.forEach((item, index) => {
        const orgItem = orgRole_webPage_right.value[index];

        if (item.name !== orgItem.name) {
          // 如果name有修改，將該項目添加到nameUpdate中
          updateData.nameUpdate.push(item);
        }

        const addedWebPages = item.webPage_data.filter(
          (webPage) =>
            !orgItem.webPage_data.some(
              (orgWebPage) => orgWebPage.webPage_id === webPage.webPage_id
            )
        );

        const removedWebPages = orgItem.webPage_data.filter(
          (orgWebPage) =>
            !item.webPage_data.some(
              (webPage) => webPage.webPage_id === orgWebPage.webPage_id
            )
        );

        const updatedWebPages = [];

        orgItem.webPage_data.forEach((orgWebPage) => {
          const updatedWebPage = item.webPage_data.find(
            (webPage) => webPage.webPage_id === orgWebPage.webPage_id
          );
          if (updatedWebPage) {
            if (!isEqual(updatedWebPage.right, orgWebPage.right)) {
              updatedWebPages.push(updatedWebPage);
            }
          }
        });

        if (
          addedWebPages.length > 0 ||
          removedWebPages.length > 0 ||
          updatedWebPages.length > 0
        ) {
          // 如果webPage_data有修改，將新增、移除或更新的角色記錄到updateData.webPageDataUpdate中
          updateData.webPageDataUpdate.push({
            role_id: item.role_id,
            addedWebPages,
            removedWebPages,
            updatedWebPages,
          });
        }
      });

      console.log(updateData);
      if (
        updateData.nameUpdate.length === 0 &&
        updateData.webPageDataUpdate.length === 0 &&
        updateData.deletedRoles.length === 0
      ) {
        methods.setTimeoutAlert("無修改項目");
        return;
      }

      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      params["methods"] = "POST";
      params["whichFunction"] = "UpdateRoleWebPageRight";
      params["updateData"] = updateData;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          methods.triggerLoadingBar();
          methods.setTimeoutAlert("修改完成");
          orgRole_webPage_right.value = {};
          queryRoleWebPageRight();
        } else {
          methods.setTimeoutAlert(response);
          methods.triggerLoadingBar();
        }
      });
    };

    //判斷是否為空物件
    function isEmptyObject(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
      return true;
    }

    const webPage = ref([
      {
        name: "總覽",
        webPage_id: "home",
        right: ["R"],
        children: [
          {
            name: "鍛造三部",
            webPage_id: "homeforging3",
            right: ["R"],
            children: [],
          },
        ],
      },
      {
        name: "即時看板",
        webPage_id: "elecboard",
        right: ["R"],
        children: [
          {
            name: "鍛造三部",
            webPage_id: "elecboardforging3",
            right: ["R"],
            children: [
              {
                name: "退火",
                webPage_id: "annealing",
                right: ["R"],
                children: [],
              },
              {
                name: "鍛造",
                webPage_id: "forging",
                right: ["R"],
                children: [],
              },
              {
                name: "加熱",
                webPage_id: "heating",
                right: ["R"],
                children: [],
              },
              {
                name: "保溫",
                webPage_id: "preheating",
                right: ["R"],
                children: [],
              },
            ],
          },
        ],
      },
      {
        name: "權限設定",
        webPage_id: "permissionsetting",
        right: ["C", "R", "U", "D"],
        children: [],
      },
    ]);
    const role_webPage_right = ref([
      {
        role_id: "admin",
        name: "系統管理員",
        webPage_data: [
          { webPage_id: "homeforging3", right: ["R"] },
          { webPage_id: "heating", right: ["R"] },
          { webPage_id: "forging", right: ["R"] },
          { webPage_id: "preheating", right: ["R"] },
          { webPage_id: "permissionsetting", right: ["C", "R", "U", "D"] },
        ],
      },
      {
        role_id: "APP",
        name: "APP手持人員",
        webPage_data: [{ webPage_id: "homeforging3", right: ["R"] }],
      },
      {
        role_id: "general",
        name: "一般職員",
        webPage_data: [{ webPage_id: "homeforging3", right: ["R"] }],
      },
      {
        role_id: "maintenance",
        name: "工務人員",
        webPage_data: [{ webPage_id: "homeforging3", right: ["R"] }],
      },
      {
        role_id: "manager",
        name: "經理",
        webPage_data: [{ webPage_id: "homeforging3", right: ["R"] }],
      },
      {
        role_id: "PC",
        name: "生管職員",
        webPage_data: [{ webPage_id: "homeforging3", right: ["R"] }],
      },
    ]);

    //計算指定頁面權限欄位總數量
    function countRightRecursive(node) {
      let count = 0;
      if (node.children.length === 0) {
        count += node.right.length;
      } else {
        for (const child of node.children) {
          count += countRightRecursive(child);
        }
      }
      return count;
    }
    //計算頁面權限欄位總數量
    function countRightInWebPage(webPage) {
      let totalRight = 0;
      for (const page of webPage) {
        totalRight += countRightRecursive(page);
      }
      return totalRight;
    }

    //計算指定頁面權限最大層數
    function countLevelsRecursive(node) {
      if (!node.children || node.children.length === 0) {
        return 1;
      } else {
        let maxChildLevel = 0;
        for (const child of node.children) {
          const childLevel = countLevelsRecursive(child);
          if (childLevel > maxChildLevel) {
            maxChildLevel = childLevel;
          }
        }
        return maxChildLevel + 1;
      }
    }
    //計算頁面權限最大層數
    function countTotalLevelsInWebPage(webPage) {
      let maxLevel = 0;
      for (const page of webPage) {
        const pageLevel = countLevelsRecursive(page);
        if (pageLevel > maxLevel) {
          maxLevel = pageLevel;
        }
      }
      rowspan.value = maxLevel;
    }

    const checkAccess = (item, ewbPage, accessType) => {
      const targetWebPageData = item.webPage_data.find(
        (data) => data.webPage_id === ewbPage.webPage_id
      );
      return targetWebPageData && targetWebPageData.right.includes(accessType);
    };

    const delCheckbox = ref([]);

    const changeAccess = (
      category = "add",
      index = 0,
      webPage_id,
      accessType
    ) => {
      if (category == "add") {
        const webPageIndex = addRole_webPage_right.value.webPage_data.findIndex(
          (data) => data.webPage_id === webPage_id
        );

        if (webPageIndex === -1) {
          // 如果找不到對應的 webPage_id，則新增一筆
          addRole_webPage_right.value.webPage_data.push({
            webPage_id,
            right: [],
          });
        }

        const updatedWebPageData =
          addRole_webPage_right.value.webPage_data.find(
            (data) => data.webPage_id === webPage_id
          );

        // 檢查是否存在該權限類型
        const accessIndex = updatedWebPageData.right.indexOf(accessType);
        if (accessIndex === -1) {
          // 如果不存在，則新增權限類型
          updatedWebPageData.right.push(accessType);
          // 新增父頁面及祖父頁面的權限
          addParentAccess(
            addRole_webPage_right.value.webPage_data,
            webPage_id,
            accessType
          );
        } else {
          // 如果存在，則移除權限類型
          updatedWebPageData.right.splice(accessIndex, 1);
        }

        // 移除空的權限類型
        if (updatedWebPageData.right.length === 0) {
          addRole_webPage_right.value.webPage_data.splice(webPageIndex, 1);
          // 移除父頁面及祖父頁面的權限
          removeParentAccess(
            addRole_webPage_right.value.webPage_data,
            webPage_id
          );
        }
      } else if (category == "mod") {
        const roleWebPageRight = role_webPage_right.value[index];
        const webPageIndex = roleWebPageRight.webPage_data.findIndex(
          (data) => data.webPage_id === webPage_id
        );

        if (webPageIndex === -1) {
          // 如果找不到對應的 webPage_id，則新增一筆
          roleWebPageRight.webPage_data.push({ webPage_id, right: [] });
        }

        const updatedWebPageData = roleWebPageRight.webPage_data.find(
          (data) => data.webPage_id === webPage_id
        );

        // 檢查是否存在該權限類型
        const accessIndex = updatedWebPageData.right.indexOf(accessType);
        if (accessIndex === -1) {
          // 如果不存在，則新增權限類型
          updatedWebPageData.right.push(accessType);
          // 新增父頁面及祖父頁面的權限
          addParentAccess(
            roleWebPageRight.webPage_data,
            webPage_id,
            accessType
          );
        } else {
          // 如果存在，則移除權限類型
          updatedWebPageData.right.splice(accessIndex, 1);
        }

        // 移除空的權限類型
        if (updatedWebPageData.right.length === 0) {
          roleWebPageRight.webPage_data.splice(webPageIndex, 1);
          // 移除父頁面及祖父頁面的權限
          removeParentAccess(roleWebPageRight.webPage_data, webPage_id);
        }
      }
    };

    function addParentAccess(webPage_data, webPage_id, accessType) {
      const parentWebPage = getParentWebPage(webPage_id);
      if (parentWebPage) {
        const parentPageIndex = webPage_data.findIndex(
          (data) => data.webPage_id === parentWebPage.webPage_id
        );
        if (parentPageIndex === -1) {
          // 新增父頁面的權限
          webPage_data.push({
            webPage_id: parentWebPage.webPage_id,
            right: [accessType],
          });
        } else {
          // 若父頁面已存在，則檢查權限是否已存在
          if (!webPage_data[parentPageIndex].right.includes(accessType)) {
            webPage_data[parentPageIndex].right.push(accessType);
          }
        }

        // 遞迴處理祖父頁面
        addParentAccess(webPage_data, parentWebPage.webPage_id, accessType);
      }
    }

    function removeParentAccess(webPage_data, webPage_id) {
      const parentWebPage = getParentWebPage(webPage_id);

      if (parentWebPage) {
        const parentPageIndex = webPage_data.findIndex(
          (data) => data.webPage_id === parentWebPage.webPage_id
        );

        // 若父頁面無其他子頁面，則遞迴處理祖父頁面
        if (!hasOtherChildren(parentWebPage, webPage_data)) {
          if (parentPageIndex !== -1) {
            // 移除父頁面的權限
            webPage_data.splice(parentPageIndex, 1);
          }
          removeParentAccess(webPage_data, parentWebPage.webPage_id);
        }
      }
    }

    function getParentWebPage(webPage_id) {
      for (const page of webPage.value) {
        if (page.webPage_id === webPage_id) {
          return null; // 如果是根頁面，則返回 null
        }
        for (const child of page.children) {
          if (child.webPage_id === webPage_id) {
            return page; // 返回找到的父級頁面
          }
          // 如果子頁面有更多的子頁面，則遞迴檢查
          const parent = getParentWebPageRecursive(child, webPage_id);
          if (parent) {
            return parent;
          }
        }
      }
      return null; // 如果找不到對應的父頁面，則返回 null
    }

    function getParentWebPageRecursive(page, webPage_id) {
      if (page.webPage_id === webPage_id) {
        return null; // 如果是根頁面，則返回 null
      }
      for (const child of page.children) {
        if (child.webPage_id === webPage_id) {
          return page; // 返回找到的父級頁面
        }
        // 如果子頁面有更多的子頁面，則遞迴檢查
        const parent = getParentWebPageRecursive(child, webPage_id);
        if (parent) {
          return parent;
        }
      }
      return null; // 如果找不到對應的父頁面，則返回 null
    }

    function hasOtherChildren(parentWebPage, webPage_data) {
      if (parentWebPage.children && parentWebPage.children.length > 0) {
        for (const child of parentWebPage.children) {
          if (
            webPage_data.some((data) => data.webPage_id === child.webPage_id)
          ) {
            return true;
          }
        }
      }
      return false;
    }

    const queryRoleWebPageRight = (
      selectKey = undefined,
      selectValue = undefined
    ) => {
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "permissionsetting";
      console.log(path.value);
      params["methods"] = "POST";
      params["whichFunction"] = "QueryRoleWebPageRight";
      firstQuery.value == false ? (params["firstQuery"] = true) : "";
      selectKey != undefined ? (params["selectKey"] = selectKey) : "";
      selectValue != undefined ? (params["selectValue"] = selectValue) : "";
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          role_webPage_right.value = QueryTableData["role_webPage_right_data"];
          if (!firstQuery.value) {
            webPage.value = QueryTableData["webPage_data"];
            roleOption.value = QueryTableData["role_option"];
            webPageOption.value = QueryTableData["webPage_option"];
            firstQuery.value = true;
            countTotalLevelsInWebPage(webPage.value);
          }
        } else {
          methods.setTimeoutAlert(response);
        }
        back();
        methods.triggerLoadingBar();
      });
    };

    //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        console.log(newValue);
        queryRoleWebPageRight(newValue.category, newValue.itemValue);
      },
      { deep: true }
    );

    const firstQuery = ref(false);
    queryRoleWebPageRight();
    countTotalLevelsInWebPage(webPage.value);

    return {
      username,
      multiInputVal,
      multiInputItems,
      roleTable,
      rowspan,
      add,
      mod,
      addRole_webPage_right,
      addRole,
      modRole,
      back,
      addRoleCheck,
      modRoleCheck,
      webPage,
      role_webPage_right,
      countRightRecursive,
      countRightInWebPage,
      countLevelsRecursive,
      countTotalLevelsInWebPage,
      checkAccess,
      delCheckbox,
      changeAccess,
    };
  },
};
</script>

<style scoped>
thead > tr:nth-child(1) > th {
  background: #4b8c80;
  color: #ffffff;
}
thead > tr:nth-child(2) > th,
thead > tr:nth-child(3) > th,
thead > tr:nth-child(4) > th,
thead > tr:nth-child(5) > th {
  background: #ccc;
  color: #000;
}
.table {
  white-space: nowrap;
}
.table > thead,
.table > thead > tr:nth-child(1) > th:nth-child(1),
.table > thead > tr:nth-child(2) > th:nth-child(1),
.table > thead > tr:nth-child(2) > th:nth-child(2) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table > thead > tr:nth-child(1) > th:nth-child(1),
.table > thead > tr:nth-child(2) > th:nth-child(1),
.table > tbody > tr > td:nth-child(1) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 0;
}
.table > thead > tr:nth-child(1) > th:nth-child(2),
.table > thead > tr:nth-child(2) > th:nth-child(2),
.table > tbody > tr > td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 150px;
}
.table.mod > thead,
.table.mod > thead > tr:nth-child(1) > th:nth-child(1),
.table.mod > thead > tr:nth-child(1) > th:nth-child(2),
.table.mod > thead > tr:nth-child(2) > th:nth-child(3) {
  position: sticky;
  top: 0;
  z-index: 2;
}
.table.mod > thead > tr:nth-child(1) > th:nth-child(2) {
  left: 65px;
}
.table.mod > thead > tr:nth-child(1) > th:nth-child(1),
.table.mod > thead > tr:nth-child(2) > th:nth-child(1),
.table.mod > tbody > tr > td:nth-child(1) {
  width: 65px;
  min-width: 65px;
  position: sticky;
  left: 0;
}
.table.mod > thead > tr:nth-child(2) > th:nth-child(2),
.table.mod > tbody > tr > td:nth-child(2) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 65px;
}
.table.mod > thead > tr:nth-child(2) > th:nth-child(3),
.table.mod > tbody > tr > td:nth-child(3) {
  white-space: normal;
  overflow-wrap: anywhere;
  width: 150px;
  min-width: 150px;
  position: sticky;
  left: 215px;
}
.changeAccessStyle {
  cursor: pointer;
}
</style>
